// All middle columns are plain editable text fields
const editableFields = [
    'friendlyName',
    'templateBusinessRole',
    'highLevelClassification',
    'description',
    'domainAttributesToAdd',
    'domainAttributesToRemove',
    'ownersToAdd',
    'ownersToRemove',
    'publishInASP',
    'comments',
    'action',
]

export const isEditable = (fieldName) => editableFields.includes(fieldName)

const getEditableConfig = (fieldName) => {
    if (!isEditable(fieldName)) return undefined
    return { type: 'text', placeholder: '' }
}

const colStyles = {
    color: '#282828',
    fontSize: '13px',
    minWidth: '150px',
}

const wideColStyles = {
    ...colStyles,
    minWidth: '180px',
}

const attributes = [
    // ── Frozen left ────────────────────────────────────────────────────────────
    {
        sticky: 'start',
        name: 'landscapeFriendlyName',
        sortable: true,
        sortBy: 'landscapeFriendlyName',
        label: 'Landscape',
        isEditable: false,
        hideValue: true,
        component: {
            componentName: 'Landscape',
            props: {
                statusIdProp: 'rtA_CSVInboxLandscapeStatusID',
            },
        },
        styles: {
            width: '120px',
            color: '#282828',
            fontSize: '13px',
        },
    },

    // ── Scrollable columns (all editable text) ─────────────────────────────────
    {
        name: 'friendlyName',
        sortable: true,
        sortBy: 'friendlyName',
        label: 'FriendlyName',
        isEditable: isEditable('friendlyName'),
        editableConfig: getEditableConfig('friendlyName'),
        styles: wideColStyles,
    },
    {
        name: 'templateBusinessRole',
        sortable: true,
        sortBy: 'templateBusinessRole',
        label: 'TemplateBusinessRole',
        isEditable: isEditable('templateBusinessRole'),
        editableConfig: getEditableConfig('templateBusinessRole'),
        styles: wideColStyles,
    },
    {
        name: 'highLevelClassification',
        sortable: true,
        sortBy: 'highLevelClassification',
        label: 'HighLevelClassification',
        isEditable: isEditable('highLevelClassification'),
        editableConfig: getEditableConfig('highLevelClassification'),
        styles: wideColStyles,
    },
    {
        name: 'description',
        sortable: true,
        sortBy: 'description',
        label: 'Description',
        isEditable: isEditable('description'),
        editableConfig: getEditableConfig('description'),
        styles: wideColStyles,
    },
    {
        name: 'domainAttributesToAdd',
        sortable: true,
        sortBy: 'domainAttributesToAdd',
        label: 'DomainAttributesToAdd',
        isEditable: isEditable('domainAttributesToAdd'),
        editableConfig: getEditableConfig('domainAttributesToAdd'),
        styles: wideColStyles,
    },
    {
        name: 'domainAttributesToRemove',
        sortable: true,
        sortBy: 'domainAttributesToRemove',
        label: 'DomainAttributesToRemove',
        isEditable: isEditable('domainAttributesToRemove'),
        editableConfig: getEditableConfig('domainAttributesToRemove'),
        styles: wideColStyles,
    },
    {
        name: 'ownersToAdd',
        sortable: true,
        sortBy: 'ownersToAdd',
        label: 'OwnersToAdd',
        isEditable: isEditable('ownersToAdd'),
        editableConfig: getEditableConfig('ownersToAdd'),
        styles: colStyles,
    },
    {
        name: 'ownersToRemove',
        sortable: true,
        sortBy: 'ownersToRemove',
        label: 'OwnersToRemove',
        isEditable: isEditable('ownersToRemove'),
        editableConfig: getEditableConfig('ownersToRemove'),
        styles: colStyles,
    },
    {
        name: 'publishInASP',
        sortable: true,
        sortBy: 'publishInASP',
        label: 'PublishInASP',
        isEditable: isEditable('publishInASP'),
        editableConfig: getEditableConfig('publishInASP'),
        styles: colStyles,
    },
    {
        name: 'comments',
        sortable: true,
        sortBy: 'comments',
        label: 'Comments',
        isEditable: isEditable('comments'),
        editableConfig: getEditableConfig('comments'),
        styles: wideColStyles,
    },
    {
        name: 'action',
        sortable: true,
        sortBy: 'action',
        label: 'Action',
        isEditable: isEditable('action'),
        editableConfig: getEditableConfig('action'),
        styles: colStyles,
    },

    // ── Frozen right ───────────────────────────────────────────────────────────
    {
        name: 'rtA_CSVInboxItemStatusName',
        sortable: true,
        sortBy: 'rtA_CSVInboxItemStatusName',
        label: 'Status',
        isEditable: false,
        hideValue: true,
        component: {
            componentName: 'InboxStatusIndicator',
            props: {
                dropdownOptionsMap: {
                    Invalid: ['Ignored'],
                    Ignored: ['Invalid'],
                },
                tooltipProp: 'rtA_CSVInboxItemStatusDescription',
                statusChangeConfig: {
                    itemIdProp: 'rtA_TemplateBusinessRoleID',
                    itemIdPayloadKey: 'rtA_TemplateBusinessRoleID',
                    statusIdPayloadKey: 'rtA_CSVInboxItemStatusID',
                    statusIdMap: {
                        'Not Validated': 1,
                        Valid: 2,
                        Invalid: 3,
                        Ignored: 4,
                        Completed: 5,
                        Error: 6,
                        'Publish Queued': 7,
                        Publishing: 8,
                    },
                },
            },
        },
        sticky: 'end',
        styles: { width: '180px' },
    },
    {
        sticky: 'end',
        styles: { width: '80px' },
        hideValue: true,
        button: { name: 'ShowHideButton' },
    },
]

export default attributes
